import { apiService } from "../../services/apiServices";
import { ActionTypes } from "../constants/actionTypes";

export const homebasesFetch = (authParams, history, handleError) => {
  return (dispatch) => {
    apiService
      .getHomebases(authParams)
      .then((response) => {
        const { data } = response;
        dispatch({
          type: ActionTypes.HOMEBASES_FETCH,
          payload: data,
        });
      })
      .catch(({ response = {} }) => {
        const { data = "Network Error!", status } = response;
        if (status === 401) return history("/unauthorized");
        handleError({ data });
      });
  };
};
